/**
 * Copied from legacy `buxus-frontend/src/modules/constants/constants.string.js`
 * (`MAPBOX_TOKEN`, `MAPBOX_STYLE_URL`) for POC parity.
 *
 * Runtime map access uses the public (`pk.`) token. Native SDK downloads use a
 * separate secret token in `apps/mobile/app.json` (RNMapboxMapsDownloadToken).
 */
export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1Ijoic2FuZGVycmVzb3VyY2VzIiwiYSI6ImNrbWV5YjRoajB5dmcyb21ubXFrejJmcjEifQ.nWFUA0FIK26bE_t0M5buGQ';

export const MAPBOX_DEFAULT_STYLE_URL =
  'mapbox://styles/sanderresources/ckpeeyp0x06sl17phjyz2rh99';

/** National all-operators pipeline map (Mapbox Studio "AllOperators"). Per-tile composite misses are intermittent and non-fatal. */
export const MAPBOX_OPERATOR_SEARCH_STYLE_URL =
  "mapbox://styles/sanderresources/ckmnrp91h3kxe17qsoc6g9hg5";

/** From legacy `constants.numeric.js` — default Sander map framing. */
export const MAPBOX_DEFAULT_LATITUDE = 34.82508;
export const MAPBOX_DEFAULT_LONGITUDE = -87.550026;
export const MAPBOX_DEFAULT_ZOOM = 4;

/** Mapbox uses [longitude, latitude]. */
export const MAPBOX_DEFAULT_LNG_LAT: [number, number] = [
  MAPBOX_DEFAULT_LONGITUDE,
  MAPBOX_DEFAULT_LATITUDE,
];

export type MapboxForwardGeocodeResult = {
  center: [number, number];
  placeName: string;
};

/** Legacy mobile `client.forwardGeocode` — Mapbox Geocoding v5 places API. */
export async function forwardGeocodeAddress(
  address: string,
  accessToken: string = MAPBOX_ACCESS_TOKEN,
): Promise<MapboxForwardGeocodeResult | null> {
  const q = address.trim();
  if (!q) return null;
  const url =
    `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(q)}.json` +
    `?access_token=${encodeURIComponent(accessToken)}&limit=1`;
  const res = await fetch(url, { headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error('Search failed');
  const data = (await res.json()) as {
    features?: { center?: [number, number]; place_name?: string }[];
  };
  const hit = data.features?.[0];
  if (!hit?.center || hit.center.length < 2) return null;
  return {
    center: [hit.center[0]!, hit.center[1]!],
    placeName: hit.place_name?.trim() || q,
  };
}
